enum TeamLevel {
  Varsity = 'Varsity',
  JV = 'JV',
  Freshman = 'Freshman'
}

export default TeamLevel;

export const getTeamLevel = (
  teamLevelId: string | undefined | null
): TeamLevel => {
  if (teamLevelId === 'c083cdee-7526-423c-a9c8-4e6da6d6f4e2') {
    return TeamLevel.JV;
  }

  if (teamLevelId === '43f49050-bdcc-4fd2-84c2-378fe5ea506a') {
    return TeamLevel.Freshman;
  }

  return TeamLevel.Varsity;
};
